export function fetchBranches(repositoryId) {
    return window.axios.get(`/backend/mass-update/branches/${repositoryId}`);
}

export function fetchConfigurations() {
    return window.axios.get('/backend/mass-update/data');
}

export function startRun(payload) {
    return window.axios.post('/backend/mass-update/start', payload);
}

export function fetchCurrentRun() {
    return window.axios.get('/backend/mass-update/run/current');
}

export function pollRunStatus(runId) {
    return window.axios.post('/backend/mass-update/run/status', {run_id: runId});
}

export function pollBuildStatuses(buildIds) {
    return window.axios.post('/backend/mass-update/status', {
        build_ids: buildIds,
    });
}

export function stopRun(runId) {
    return window.axios.post('/backend/mass-update/run/stop', {run_id: runId});
}
